import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-table-of-contents" }
const _hoisted_2 = { class: "gfu-table-of-contents__wrapper" }
const _hoisted_3 = { class: "_flexcol _gap-2 _ai-fe" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.lines, (line, i) => {
          return (_openBlock(), _createBlock(_component_skeleton_line, {
            key: i,
            "width-percent": line,
            class: "gfu-background-swept _pos-r"
          }, null, 8 /* PROPS */, ["width-percent"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}